import React, { useState, useEffect } from 'react';

const FloatingWhatsApp = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={`fixed bottom-6 right-6 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <a
                href="tel:+94777880894"
                className="group flex items-center justify-center w-14 h-14 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 relative"
                aria-label="Call us now"
            >
                <span className="absolute right-full mr-3 bg-white text-slate-800 text-xs font-bold px-2 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap hidden sm:block">
                    Call Now
                </span>
                <i className="fas fa-phone-alt text-2xl"></i>

                {/* Pulse effect */}
                <span className="absolute inline-flex h-full w-full rounded-full bg-green-600 opacity-20 animate-ping"></span>
            </a>
        </div>
    );
};

export default FloatingWhatsApp;
